import { render, staticRenderFns } from "./unreadEventsCount.vue?vue&type=template&id=fca65d80"
import script from "./unreadEventsCount.vue?vue&type=script&lang=js"
export * from "./unreadEventsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports